require("core-js/modules/es.array.reduce.js");

var _toConsumableArray = require("/app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _defineProperty = require("/app/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/app/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.ReactSimplyCarousel = t(require("react")) : e.ReactSimplyCarousel = t(e.React);
}(this, function (e) {
  return function () {
    var t = {
      154: function _(e) {
        function t() {
          return e.exports = t = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];

              for (var n in r) {
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
              }
            }

            return e;
          }, t.apply(this, arguments);
        }

        e.exports = t;
      },
      767: function _(e, t, r) {
        "use strict";

        r.r(t), r.d(t, {
          default: function _default() {
            return s;
          }
        });
        var n = r(154),
            o = r.n(n),
            a = r(383),
            c = r.n(a);

        function l(_ref) {
          var e = _ref.responsiveProps,
              t = _objectWithoutProperties(_ref, ["responsiveProps"]);

          var _ref2 = (0, a.useState)(0),
              _ref3 = _slicedToArray(_ref2, 2),
              r = _ref3[0],
              n = _ref3[1],
              _ref4 = (0, a.useState)(t.activeSlideIndex),
              _ref5 = _slicedToArray(_ref4, 2),
              l = _ref5[0],
              s = _ref5[1],
              u = (0, a.useRef)(null),
              i = (0, a.useRef)(null),
              d = (0, a.useRef)(null),
              f = (0, a.useRef)(null),
              m = (0, a.useRef)(!1),
              p = (0, a.useRef)(""),
              h = (0, a.useRef)(null),
              b = (0, a.useRef)(null),
              v = (0, a.useRef)(0),
              w = e.reduce(function (e) {
            var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                _ref7$minWidth = _ref7.minWidth,
                t = _ref7$minWidth === void 0 ? 0 : _ref7$minWidth,
                _ref7$maxWidth = _ref7.maxWidth,
                n = _ref7$maxWidth === void 0 ? null : _ref7$maxWidth,
                o = _objectWithoutProperties(_ref7, ["minWidth", "maxWidth"]);

            return r > t && (!n || r <= n) ? _objectSpread(_objectSpread({}, e), o) : e;
          }, t),
              y = a.Children.toArray(w.children),
              _ref6 = r ? _objectSpread(_objectSpread({}, w), {}, {
            activeSlideIndex: Math.max(0, Math.min(w.activeSlideIndex, y.length - 1)),
            itemsToShow: Math.min(y.length, w.itemsToShow),
            itemsToScroll: Math.min(y.length, w.itemsToScroll)
          }) : t,
              _ref6$containerProps = _ref6.containerProps,
              C = _ref6$containerProps.style,
              k = _ref6$containerProps.onClickCapture,
              x = _objectWithoutProperties(_ref6$containerProps, ["style", "onClickCapture"]),
              _ref6$innerProps = _ref6.innerProps,
              g = _ref6$innerProps.style,
              E = _objectWithoutProperties(_ref6$innerProps, ["style"]),
              _ref6$itemsListProps = _ref6.itemsListProps,
              S = _ref6$itemsListProps.style,
              L = _ref6$itemsListProps.onTouchStart,
              P = _ref6$itemsListProps.onMouseDown,
              T = _ref6$itemsListProps.onTransitionEnd,
              W = _objectWithoutProperties(_ref6$itemsListProps, ["style", "onTouchStart", "onMouseDown", "onTransitionEnd"]),
              _ref6$backwardBtnProp = _ref6.backwardBtnProps,
              _ref6$backwardBtnProp2 = _ref6$backwardBtnProp.children,
              M = _ref6$backwardBtnProp2 === void 0 ? null : _ref6$backwardBtnProp2,
              _ref6$backwardBtnProp3 = _ref6$backwardBtnProp.show,
              R = _ref6$backwardBtnProp3 === void 0 ? !0 : _ref6$backwardBtnProp3,
              I = _objectWithoutProperties(_ref6$backwardBtnProp, ["children", "show"]),
              _ref6$forwardBtnProps = _ref6.forwardBtnProps,
              _ref6$forwardBtnProps2 = _ref6$forwardBtnProps.children,
              j = _ref6$forwardBtnProps2 === void 0 ? null : _ref6$forwardBtnProps2,
              _ref6$forwardBtnProps3 = _ref6$forwardBtnProps.show,
              O = _ref6$forwardBtnProps3 === void 0 ? !0 : _ref6$forwardBtnProps3,
              X = _objectWithoutProperties(_ref6$forwardBtnProps, ["children", "show"]),
              _ref6$activeSlideProp = _ref6.activeSlideProps,
              _ref6$activeSlideProp2 = _ref6$activeSlideProp.className,
              A = _ref6$activeSlideProp2 === void 0 ? "" : _ref6$activeSlideProp2,
              _ref6$activeSlideProp3 = _ref6$activeSlideProp.style,
              N = _ref6$activeSlideProp3 === void 0 ? {} : _ref6$activeSlideProp3,
              z = _objectWithoutProperties(_ref6$activeSlideProp, ["className", "style"]),
              D = _ref6.updateOnItemClick,
              B = _ref6.activeSlideIndex,
              V = _ref6.onRequestChange,
              _ = _ref6.speed,
              q = _ref6.delay,
              F = _ref6.easing,
              G = _ref6.itemsToShow,
              H = _ref6.itemsToScroll,
              J = _ref6.children,
              K = _ref6.onAfterChange,
              Q = _ref6.autoplay,
              U = _ref6.autoplayDirection,
              Y = _ref6.disableNavIfAllVisible,
              Z = _ref6.hideNavIfAllVisible,
              $ = _ref6.centerMode,
              ee = (0, a.useMemo)(function () {
            return r ? _toConsumableArray(d.current.children).slice(y.length - l, y.length - l + y.length) : [];
          }, [l, y.length, r]),
              te = (0, a.useCallback)(function () {
            return l - B == 0 ? 0 : "forward" === p.current.toLowerCase() && B < l ? d.current.offsetWidth / 3 : "backward" === p.current.toLowerCase() && B > l ? -d.current.offsetWidth / 3 : 0;
          }, [B, l]),
              re = function re(e) {
            return ee.reduce(function (t, r, n) {
              return n >= e ? t : t + (r.offsetWidth || 0);
            }, 0);
          },
              ne = r && G ? ee.reduce(function (e, t, r) {
            return r >= B && r < B + G || r < B && r < B + G - ee.length ? e + t.offsetWidth : e;
          }, 0) : null,
              oe = a.Children.count(J) - 1,
              ae = G === y.length,
              ce = Z && ae,
              le = Y && ae,
              se = B - l != 0,
              ue = r && se ? re(l) : 0,
              ie = r && se ? re(B) : 0,
              de = r ? ee[B].offsetWidth : 0,
              fe = r && $ ? -(Math.min(ne || i.current.offsetWidth, i.current.offsetWidth) - de) / 2 : 0,
              me = se && (_ || q) ? "transform ".concat(_, "ms ").concat(F, " ").concat(q, "ms") : null,
              pe = le || !r ? 0 : ie - ue + fe + te() + d.current.offsetWidth / 3,
              he = r ? "translateX(-".concat(pe, "px)") : null,
              be = (0, a.useCallback)(function (e) {
            if ("forward" === e) {
              var _e = B + H;

              return _e > oe ? _e - oe - 1 : _e;
            }

            if ("backward" === e) {
              var _e2 = B - H;

              return _e2 < 0 ? oe + 1 + _e2 : _e2;
            }

            return B;
          }, [B, H, oe]),
              ve = (0, a.useCallback)(function () {
            clearTimeout(h.current);
          }, []),
              we = (0, a.useCallback)(function () {
            s(B);
          }, [B]),
              ye = (0, a.useCallback)(function (e, t) {
            p.current = t, d.current.style.transition = _ || q ? "transform ".concat(_, "ms ").concat(F, " ").concat(q, "ms") : null, e !== B ? (ve(), V(e)) : (f.current = null, m.current = !1, d.current.style.transform = "translateX(-".concat(fe + d.current.offsetWidth / 3, "px)"));
          }, [B, fe, q, F, _, ve, V]),
              Ce = (0, a.useCallback)(function () {
            Q && (ve(), h.current = setTimeout(function () {
              ye(be(U), U);
            }, q));
          }, [Q, U, ye, be, q, ve]),
              ke = (0, a.useCallback)(function (e) {
            m.current && (e.preventDefault(), e.stopPropagation(), k && k(e));
          }, [k]),
              xe = (0, a.useCallback)(function () {
            ye(be("backward"), "backward");
          }, [ye, be]),
              ge = (0, a.useCallback)(function (e) {
            var t = f.current - e + fe + d.current.offsetWidth / 3,
                r = d.current.offsetWidth - i.current.offsetWidth,
                n = Math.max(Math.min(0, -t), -r);
            d.current.style.transition = "none", d.current.style.transform = "translateX(".concat(n, "px)");
          }, [fe]),
              Ee = (0, a.useCallback)(function (e) {
            var t = f.current - e;
            t > de / 2 ? ye(be("forward"), "forward") : t < -de / 2 ? ye(be("backward"), "backward") : ye(B, "forward");
          }, [B, de, ye, be]),
              Se = (0, a.useCallback)(function (e) {
            m.current = !0, ge(e.clientX);
          }, [ge]),
              Le = (0, a.useCallback)(function (e) {
            d.current.removeEventListener("mouseout", Le), d.current.removeEventListener("dragstart", Le), document.removeEventListener("mousemove", Se), document.removeEventListener("mouseup", Le), m.current && Ee(e.clientX);
          }, [Ee, Se]),
              Pe = (0, a.useCallback)(function (e) {
            ve(), m.current || (f.current = e.clientX, document.addEventListener("mousemove", Se), document.addEventListener("mouseup", Le), d.current.addEventListener("mouseout", Le), d.current.addEventListener("dragstart", Le));
          }, [Se, Le, ve]),
              Te = (0, a.useCallback)(function (e) {
            m.current = !0, ge(e.touches[0].clientX);
          }, [ge]),
              We = (0, a.useCallback)(function (e) {
            document.removeEventListener("touchmove", Te), document.removeEventListener("touchend", We), m.current && Ee(e.changedTouches[e.changedTouches.length - 1].clientX);
          }, [Ee, Te]),
              Me = (0, a.useCallback)(function (e) {
            ve(), m.current || (f.current = e.touches[0].clientX, document.addEventListener("touchmove", Te), document.addEventListener("touchend", We));
          }, [Te, We, ve]),
              Re = (0, a.useCallback)(function () {
            ye(be("forward"), "forward");
          }, [ye, be]),
              Ie = function Ie(e, t, r) {
            return e.map(function (e, n) {
              var _e$props = e.props;
              _e$props = _e$props === void 0 ? {} : _e$props;

              var _e$props$className = _e$props.className,
                  o = _e$props$className === void 0 ? "" : _e$props$className,
                  a = _e$props.onClick,
                  _e$props$style = _e$props.style,
                  c = _e$props$style === void 0 ? {} : _e$props$style,
                  l = _objectWithoutProperties(_e$props, ["className", "onClick", "style"]),
                  s = _objectWithoutProperties(e, ["props"]),
                  u = v.current >= y.length ? "forward" : "backward",
                  i = n + t === B,
                  d = _objectSpread(_objectSpread({
                role: "tabpanel",
                className: "".concat(o, " ").concat(i ? A : ""),
                style: _objectSpread(_objectSpread(_objectSpread({}, c), i ? N : {}), {}, {
                  boxSizing: "border-box",
                  margin: 0
                }),
                onClick: !r && D ? function (_ref8) {
                  var e = _ref8.direction,
                      t = _ref8.index,
                      r = _ref8.onClick;
                  return function (n) {
                    ye(t, e || (B < t ? "forward" : "") || (B > t ? "backward" : "")), r && r(n);
                  };
                }({
                  direction: u,
                  index: n + t,
                  onClick: a
                }) : a
              }, l), i ? z : {});

              return v.current += 1, _objectSpread({
                props: d
              }, s);
            });
          },
              je = (0, a.useCallback)(function () {
            n(window.innerWidth);
          }, []),
              Oe = (0, a.useCallback)(function () {
            clearTimeout(b.current), ve(), b.current = setTimeout(je, 400);
          }, [je, ve]);

          return (0, a.useEffect)(function () {
            return f.current = null, m.current = !1, p.current = "", B !== l ? _ || q || we() : (K && K(B, l), Ce()), function () {
              ve();
            };
          }, [l, B, K, _, q, we, Ce, ve]), (0, a.useEffect)(function () {
            return r && !h.current && Ce(), function () {
              ve();
            };
          }, [r, ve, Ce]), (0, a.useEffect)(function () {
            var e = d.current;
            return je(), window.addEventListener("resize", Oe), function () {
              clearTimeout(b.current), window.removeEventListener("resize", Oe), document.removeEventListener("mousemove", Se), document.removeEventListener("mouseup", Le), document.removeEventListener("touchmove", Te), document.removeEventListener("touchend", We), e.removeEventListener("mouseout", Le), e.removeEventListener("dragstart", Le);
            };
          }, [Se, Oe, Le, Te, We, je]), v.current = 0, c().createElement("div", o()({
            onClickCapture: ke,
            style: _objectSpread({
              display: "flex",
              boxSizing: "border-box",
              justifyContent: "center"
            }, C || {})
          }, x, {
            ref: u
          }), R && !ce && c().createElement("button", o()({}, I, {
            type: "button",
            onClick: xe
          }), M), c().createElement("div", o()({
            style: _objectSpread({
              display: "flex",
              boxSizing: "border-box",
              flexFlow: "row wrap",
              padding: "0",
              overflow: "hidden",
              maxWidth: ne ? "".concat(ne, "px") : "100%"
            }, g)
          }, E, {
            ref: i
          }), c().createElement("div", o()({
            style: _objectSpread(_objectSpread({
              display: "flex",
              boxSizing: "border-box",
              outline: "none"
            }, S || {}), {}, {
              transition: me,
              transform: he
            }),
            onTouchStart: le ? null : Me,
            onMouseDown: le ? null : Pe,
            onTransitionEnd: _ || q ? we : null,
            tabIndex: "-1",
            role: "presentation"
          }, W, {
            ref: d
          }), !le && Ie(y.slice(l), l), Ie(y, 0, le), !le && Ie(y, 0), !le && Ie(y.slice(0, l), 0))), O && !ce && c().createElement("button", o()({}, X, {
            type: "button",
            onClick: Re
          }), j));
        }

        l.defaultProps = {
          activeSlideProps: {},
          autoplay: !1,
          autoplayDirection: "forward",
          backwardBtnProps: {},
          children: null,
          containerProps: {},
          delay: 0,
          disableNavIfAllVisible: !0,
          easing: "linear",
          forwardBtnProps: {},
          hideNavIfAllVisible: !0,
          innerProps: {},
          itemsListProps: {},
          itemsToScroll: 1,
          itemsToShow: 0,
          onAfterChange: null,
          responsiveProps: [],
          speed: 0,
          updateOnItemClick: !1,
          centerMode: !1
        };
        var s = (0, a.memo)(l);
      },
      383: function _(t) {
        "use strict";

        t.exports = e;
      }
    },
        r = {};

    function n(e) {
      if (r[e]) return r[e].exports;
      var o = r[e] = {
        exports: {}
      };
      return t[e](o, o.exports, n), o.exports;
    }

    return n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, {
        a: t
      }), t;
    }, n.d = function (e, t) {
      for (var r in t) {
        n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
          enumerable: !0,
          get: t[r]
        });
      }
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n(767);
  }();
});